import getApiClient from 'src/utils/getApiClient'
import type { ApiSearchParamsPost, ApiSearchResponsePost } from 'src/layouts/core-layout/components/CoreSearch/api/apiSearch.types'

const apiClient = getApiClient()

export default {
  post(params: ApiSearchParamsPost) {
    return apiClient.post<ApiSearchResponsePost>('/api/search/', params)
  },
}
